import { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDefaultDirectionWithGlobal } from '../../helper/module';



export function GetDefaultMaincss() {
  const [data, setData] = useState(null);
  const direction = useSelector((state) => state.SharedData.direction)


  
  useEffect(() => {

    if (!data) {
      if (direction) {
        const Maincss = require(`!!raw-loader!../../helper/RtlLtrCssSelector/Css/${direction}.css`);
        setData(Maincss?.default)
      } else {
        const Maincss = require(`!!raw-loader!../../helper/RtlLtrCssSelector/Css/${getDefaultDirectionWithGlobal(global.config.defaultLanguage) || "Ltr"}.css`);
        setData(Maincss?.default)
      }

    }


  }, [direction]);


  useEffect(() => {

    if (direction) {
      const Maincss = require(`!!raw-loader!../../helper/RtlLtrCssSelector/Css/${direction}.css`);
      setData(Maincss?.default)
    } else {
      const Maincss = require(`!!raw-loader!../../helper/RtlLtrCssSelector/Css/${getDefaultDirectionWithGlobal(global.config.defaultLanguage) || "Ltr"}.css`);
      setData(Maincss?.default)
    }

  }, []);


  return data;
};

